export const FETCH_DRIVER_INIT = 'FETCH_DRIVER_INIT';
export const FETCH_DRIVER_SUCCESS = 'FETCH_DRIVER_SUCCESS';
export const FETCH_DRIVER_FAILURE = 'FETCH_DRIVER_FAILURE';

export const FETCH_EQUIP_INIT = 'FETCH_EQUIP_INIT';
export const FETCH_EQUIP_SUCCESS = 'FETCH_EQUIP_SUCCESS';
export const FETCH_EQUIP_FAILURE = 'FETCH_EQUIP_FAILURE';

export const FETCH_TEST_INIT = 'FETCH_TEST_INIT';
export const FETCH_TEST_SUCCESS = 'FETCH_TEST_SUCCESS';
export const FETCH_TEST_FAILURE = 'FETCH_TEST_FAILURE';

export const IF_DRIVER_EXIST = 'IF_DRIVER_EXIST';

export const ADD_ASIGNATION = 'ADD_ASIGNATION';
export const DELETE_ASIGNATION = 'DELETE_ASIGNATION';
export const CHANGE_NAME = 'CHANGE_NAME';
export const IS_DUPLICATE = 'IS_DUPLICATE';



// WEBPACK FOOTER //
// ./source/client/actions/allocator/types.js